import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../../lib/utils";

// Level-1 navigation: full-width underline tabs. All tabs stay visible (wrap on narrow screens).
export const UnderlineTabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("flex w-full flex-wrap items-stretch gap-x-1 border-b-2 border-border", className)}
    {...props}
  />
));
UnderlineTabsList.displayName = "UnderlineTabsList";

export const UnderlineTabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "relative -mb-[2px] inline-flex items-center justify-center gap-2 whitespace-nowrap px-4 py-3 text-sm font-semibold text-muted-foreground border-b-[3px] border-transparent transition-colors",
      "hover:text-foreground hover:bg-muted/60 rounded-t-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "data-[state=active]:text-foreground data-[state=active]:border-primary data-[state=active]:bg-primary/5",
      className
    )}
    {...props}
  />
));
UnderlineTabsTrigger.displayName = "UnderlineTabsTrigger";

// Level-2 navigation: segmented control (light track, white active pill).
export const SegmentedTabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("inline-flex flex-wrap items-center gap-1 rounded-lg bg-muted p-1", className)}
    {...props}
  />
));
SegmentedTabsList.displayName = "SegmentedTabsList";

export const SegmentedTabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3.5 py-1.5 text-sm font-medium text-muted-foreground transition-all",
      "hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:font-semibold",
      className
    )}
    {...props}
  />
));
SegmentedTabsTrigger.displayName = "SegmentedTabsTrigger";
